import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=41cf2975&scoped=true"
import script from "./event-list.vue?vue&type=script&lang=js"
export * from "./event-list.vue?vue&type=script&lang=js"
import style0 from "./event-list.vue?vue&type=style&index=0&id=41cf2975&prod&lang=scss&scoped=true"
import style1 from "./event-list.vue?vue&type=style&index=1&id=41cf2975&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cf2975",
  null
  
)

export default component.exports